import { render, staticRenderFns } from "./DiamondForge.vue?vue&type=template&id=559d7bba"
import script from "./DiamondForge.vue?vue&type=script&lang=js"
export * from "./DiamondForge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports